<div class="content">
  <div class="card">
    <div class="card-content">
      <div class="card-body">

        <button *ngIf='!isList' routerLink="/users" title="{{ 'inputs.back' | translate }}" mat-icon-button>
          <mat-icon>keyboard_backspace</mat-icon>
          {{ 'inputs.back' | translate }}
        </button>

        <h1 *ngIf='isList'>{{ 'titles.list.user' | translate }}</h1>
        <h1 *ngIf='!isList'>{{ 'titles.edit.user' | translate }}</h1>
        <div *ngIf='!isList && !isNew'>
          {{ 'inputs.creation_date' | translate }}: {{creation_date | date:'d/M/Y, H:mm:ss'}} <br>
          {{ 'inputs.modification_date' | translate }}: {{modification_date | date:'d/M/Y, H:mm:ss'}}
        </div>


        <div class="media-body">

          <mat-form-field *ngIf='isList' [formGroup]="searchForm">
            <mat-label>{{ 'inputs.search' | translate }}</mat-label>
            <input matInput [formControlName]="'search'" (keyup.enter)="applyFilter($event)" id=input placeholder="{{ 'inputs.search' | translate }}"
              #input>
          </mat-form-field>

          <mat-form-field appearance="legacy" style="float:right" [formGroup]="filterForm" *ngIf='isList'>
            <mat-label>{{ 'inputs.role' | translate }}</mat-label>
            <mat-select matNativeControl required [formControlName]="'role'"(selectionChange)="applyFilter($event.value)">
              <mat-option value="superadmin" *ngIf="role=='superadmin'">{{ 'inputs.superadmin' | translate }}</mat-option>
              <mat-option value="admin" >{{ 'inputs.admin' | translate }}</mat-option>
              <mat-option value="school">{{ 'inputs.responsable' | translate }}</mat-option>
              <mat-option value="family">{{ 'inputs.family' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div *ngIf='isList'>
            <!-- && dataSource -->
            <table mat-table [dataSource]="dataSource">

              <!-- Second Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef  fxHide.lt-sm> {{ 'tables.name' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm> {{element.name}} </td>
              </ng-container>

              <!-- Third Column -->
              <!-- <ng-container matColumnDef="manager">
                <th mat-header-cell *matHeaderCellDef fxHide.lt-sm> {{ 'tables.manager' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm>{{element.manager_name}}
                </td>
              </ng-container> -->
              <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef fxHide.lt-sm> {{ 'tables.role' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" fxHide.lt-sm>{{element.role}}</td>
              </ng-container>
              <!-- Fourth Column -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> {{ 'tables.email' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.id)" > {{element.email }} </td>
              </ng-container>
              <!-- Action Column -->
              <ng-container matColumnDef="actions" class="actionsColumn">
                <th mat-header-cell *matHeaderCellDef> {{ 'tables.actions' | translate }} </th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button matTooltip="Click to Delete" class="iconbutton" (click)="delete(element.id)"
                    color="warn">
                    <mat-icon>delete</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="Click to reset password" class="iconbutton"
                    (click)="resetPassword(element.id)">
                    <mat-icon>vpn_key</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="{{'inputs.edit' | translate}}" (click)="goTo(element.id)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button *ngIf = "!element.last_login" style ="cursor: default; color: darkgray">
                    <mat-icon>info</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="{{'inputs.last_login' | translate}}: {{element.last_login | date:'d/M/Y, H:mm:ss'}}" *ngIf = "element.last_login"  style ="cursor: default; color: #5fbeb5">
                    <mat-icon>info</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="{{'inputs.notifications_ko' | translate}}" *ngIf = "element.allow_notifications == false" style ="color: darkgray" (click)="toggle_notifications(element.id)">
                    <mat-icon>notifications</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="{{'inputs.notifications_ok' | translate}}" *ngIf = "element.allow_notifications != false"  style ="color: #5fbeb5" (click)="toggle_notifications(element.id)">
                    <mat-icon>notifications</mat-icon>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="loading">
                <td mat-footer-cell *matFooterCellDef colspan="6">
                  <span>{{ 'tables.loading' | translate }}</span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr mat-footer-row *matFooterRowDef="['loading']" [hidden]="!showUsersProgressBar"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" *ngIf="!firstTime" colspan="4">{{ 'tables.no_data_found' | translate }}</td>
                <td class="mat-cell" *ngIf="firstTime" colspan="4">{{ 'tables.search_to_view' | translate }}</td>
              </tr>
            </table>
            <mat-progress-bar *ngIf="showUsersProgressBar" mode="indeterminate"></mat-progress-bar>
            <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="[100, 10, 20,50]"
              (page)="pageEvent = $event; onPaginateChange($event)" showFirstLastButtons>
            </mat-paginator>

          </div>


          <!-- <mat-card *ngIf='!isList'> -->
          <div class="contenedor" [formGroup]="userForm" *ngIf='!isList'>
            <input matInput [hidden]="true" [formControlName]="'id'" type="text" placeholder="id">
            <mat-form-field>
              <input matInput required [formControlName]="'name'" type="text"
                placeholder="{{ 'inputs.name' | translate }}">
            </mat-form-field>

            <mat-form-field>
              <input matInput required [formControlName]="'phone'" type="text"
                placeholder="{{ 'inputs.phone' | translate }}">
            </mat-form-field>

            <!-- <mat-form-field>
              <input matInput [formControlName]="'last_name'" type="text" placeholder="{{ 'inputs.surname' | translate }}">
            </mat-form-field> -->

            <mat-form-field>
              <input matInput required [formControlName]="'email'" readonly='{{readOnly}}' type="email"
                placeholder="{{ 'inputs.email' | translate }}">
            </mat-form-field>

            <!-- <mat-form-field>
              <input matInput type="password" placeholder="Password" formControlName="password" (input)="onPasswordInput()">
              <mat-error *ngIf="password.hasError('required')">Password is required</mat-error>
              <mat-error *ngIf="password.hasError('minlength')">Password must have at least {{minPw}} characters</mat-error>
            </mat-form-field>
          
            <mat-form-field>
              <input matInput type="password" placeholder="Confirm password" formControlName="password2" (input)="onPasswordInput()">
              <mat-error *ngIf="password2.hasError('required')">Please confirm your password</mat-error>
              <mat-error *ngIf="password2.invalid && !password2.hasError('required')">Passwords don't match</mat-error>
            </mat-form-field>
            <br> -->

            <!-- <mat-form-field appearance="legacy">
              <mat-label>{{ 'inputs.manager' | translate }}</mat-label>
              <mat-select matNativeControl [formControlName]="'manager'">
                <mat-option *ngFor="let manager of managers" [value]="manager.id">
                  {{manager.name}}
                </mat-option>
              </mat-select>
            </mat-form-field> -->

            <mat-form-field appearance="legacy">
              <mat-label>{{ 'inputs.role' | translate }}</mat-label>
              <mat-select matNativeControl required [formControlName]="'role'">
                <mat-option value="superadmin" *ngIf="role=='superadmin'">{{ 'inputs.superadmin' | translate }}</mat-option>
                <mat-option value="admin" >{{ 'inputs.admin' | translate }}</mat-option>
                <mat-option value="school">{{ 'inputs.responsable' | translate }}</mat-option>
                <mat-option value="family">{{ 'inputs.family' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!-- </mat-card> -->



          <div class="float-button-container" *ngIf='isList'>
            <button mat-fab color="primary" aria-label="add" (click)="newUser()">
              <mat-icon>plus_one</mat-icon>
            </button>
          </div>
          <div class="float-button-container" *ngIf='!isList'>
            <button mat-fab color="primary" aria-label="save" (click)="saveUser()">
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="card" *ngIf='!isList && !isNew'>
    <div class="card-content">
      <div class="card-body">
        <app-relationships ></app-relationships>
      </div>
    </div>
    
  </div>
  

  <div class="card" *ngIf="!isList && !isNew && userForm.value.role == 'school'">
    <div class="card-content">
      <div class="card-body">
        <app-relationshipuserschools></app-relationshipuserschools>
      </div>
    </div>
    
  </div>

  <div class="card" *ngIf='!isList && !isNew'>
    <div class="card-content">
      <div class="card-body">
        <app-relationships-user-reportages ></app-relationships-user-reportages>
      </div>
    </div>
    
  </div>
  <div *ngIf='!isList && !isNew' class="orders">
        <app-order-family></app-order-family>
  </div>
</div>